import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStoreService } from '../services/auth-store.service';

/** Only SUPERADMIN can manage organizations (create/edit/list all of them). */
export const superAdminGuard: CanActivateFn = async () => {
  const authStore = inject(AuthStoreService);
  const router = inject(Router);

  await authStore.initialize();

  if ((authStore.user()?.type || []).includes('SUPERADMIN')) {
    return true;
  }

  return router.createUrlTree(['/admin']);
};

/** ADMIN/SUPERADMIN manage users and departments; a plain MANAGER (Gestor) cannot, regardless of their permissions. */
export const orgAdminGuard: CanActivateFn = async () => {
  const authStore = inject(AuthStoreService);
  const router = inject(Router);

  await authStore.initialize();

  const roles = authStore.user()?.type || [];
  if (roles.includes('SUPERADMIN') || roles.includes('ADMIN')) {
    return true;
  }

  return router.createUrlTree(['/admin']);
};
